import type { Store } from '@reduxjs/toolkit';

let reduxStore: Store | null = null;

/** Called once from `store/index` after `configureStore` (avoids axios ↔ store cycles). */
export function setReduxStore(store: Store): void {
  reduxStore = store;
}

export function getReduxStore(): Store {
  if (!reduxStore) {
    throw new Error('Redux store is not initialized yet');
  }
  return reduxStore;
}
